import React, { useState } from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { isEmpty, startCase } from "lodash";

import OutsideClickHandler from "react-outside-click-handler";
import {
  filterarcade,
  filtercasion,
  filtercrash,
  filterfishing,
  filterlotto,
  filterslot,
  filtertable,
} from "../Pages/casino/ListHome";
import { t } from "i18next";
import ThemeContext from "../context/ThemeContext";
import FadeInWhenVisible from "./FadeInWhenVisible";
import Loader from "./Loader";
const Menu = () => {
  const setLogoutShow = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLogoutShow;
  });

  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const setSidebarModalAccount = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModalAccount;
  });
  const setSidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModal;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });
  const toggleTheme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.toggleTheme;
  });
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });
  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const [show, setShow] = useState(false);
  const getImageUrl = (url) => {
    return url;
  };
  return (
    <>
      <div
        id="menu"
        className={`menu ng-tns-c810532393-10 player ng-star-inserted show ${
          sidebarModal ? "active" : ""
        }`}
      >
        <div
          onClick={() => {
            setSidebarModal(false);
            setShow(false);
          }}
          className={`btn-close ng-tns-c810532393-4 ${
            show ? "is-open-member-menu" : ""
          }`}
          style={{
            maskImage: 'url("/assets/Other/icon-close.svg")',
          }}
        />
      
          <div className="menu-first ng-tns-c810532393-4">
            <div
              className="menu-top ng-tns-c810532393-4"
              style={{ opacity: 1, transform: "translate(0px, 0px)" }}
            >
              <div className="menu-header ng-tns-c810532393-4">
                <Loader type="head-coin" />

                {isEmpty(user) ? (
                  <div className="member-name ng-tns-c810532393-4 ng-star-inserted">
                    <span className="ng-tns-c810532393-4 ng-star-inserted">
                      {t("HiWelcome")}
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="member-name ng-tns-c810532393-4 ng-star-inserted">
                      <div
                        id="account"
                        className="account ng-tns-c810532393-4 ng-star-inserted"
                      >
                        <span className="ng-tns-c810532393-4 ng-star-inserted">
                          {user?.user?.username}
                        </span>
                      </div>

                      <p
                        id="profile_text"
                        className="ng-tns-c810532393-4"
                        style={{ display: "flex" }}
                      >
                        {" "}
                        {t("Profile")}
                      </p>
                      {/* <div className="vip-points ng-tns-c810532393-4 ng-star-inserted">
                            <div className="vip-points-text ng-tns-c810532393-4">
                              {t("VIPPointsVP")}
                            </div>
                            <span className="ng-tns-c810532393-4">0</span>
                          </div> */}
                    </div>
                    <div
                      onClick={() => {
                        if (!isEmpty(user)) {
                          setSidebarModalAccount(true);
                          setSidebarModal(false);
                          setShow(false);
                        }
                      }}
                      className="icon-arrow ng-tns-c810532393-4 ng-star-inserted"
                      style={{
                        maskImage: 'url("/assets/Icon/icon-arrow-type01.svg")',
                        display: "flex",
                      }}
                    />
                  </>
                )}
              </div>
              {isEmpty(user) ? (
                <div className="beforelogin ng-tns-c810532393-4 ng-star-inserted">
                  <div className="login-button ng-tns-c810532393-4">
                    <span
                      className="ng-tns-c810532393-4"
                      style={{
                        maskImage: 'url("/assets/Icon/icon-login-s.svg")',
                      }}
                    />
                    <Link
                      style={{ textTransform: "uppercase" }}
                      to="/login"
                      className="ng-tns-c810532393-4"
                    >
                      {startCase(t("Login"))}
                    </Link>
                  </div>
                  <div className="register-button ng-tns-c810532393-4">
                    <span
                      className="ng-tns-c810532393-4"
                      style={{
                        maskImage: 'url("/assets/Icon/icon-register.svg")',
                      }}
                    />
                    <Link
                      style={{ textTransform: "uppercase" }}
                      to={"/register"}
                      className="ng-tns-c810532393-4"
                    >
                      {startCase(t("Singup"))}
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="afterlogin marquee ng-tns-c810532393-4 ng-star-inserted">
                  <div className="main-wallet ng-tns-c810532393-4">
                    <div className="wallet ng-tns-c810532393-4">
                      {" "}
                      {t("MainWallet")}
                      <div
                        onClick={() => amounutRefresh()}
                        className="icon-refresh ng-tns-c810532393-4"
                        style={{
                          "mask-image":
                            'url("/assets/Icon/icon-refresh-type01.svg")',
                        }}
                      />
                    </div>
                    <div className="amount ng-tns-c810532393-4">
                      <span
                        data-currency="$"
                        className="amount ng-tns-c810532393-4"
                      >
                        <i className="ng-tns-c810532393-4">
                          ৳{userCoins?.totalCoins}
                        </i>
                      </span>
                    </div>
                  </div>
                  {/* 
                      <div
                        onClick={() => navigate("/message")}
                        className="btn-wallet ng-tns-c810532393-4"
                      >
                        <span
                          className="icon-message ng-tns-c810532393-4"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-email.svg",
                            )})`,
                          }}
                        />
                        <span className="icon-message-bg ng-tns-c810532393-4">
                          <span className="notice inbox ng-tns-c810532393-4 ng-star-inserted">
                            {" "}
                            1{" "}
                          </span>
                        </span>
                      </div> */}
                </div>
              )}
            </div>

            <div className="menu-item ng-tns-c810532393-4">
              <div className="ng-tns-c810532393-4">
                {!isEmpty(user) && (
                  <ul className="wallet-box ng-tns-c810532393-4 ng-star-inserted">
                    <FadeInWhenVisible category={"deposit"}>
                      <Link
                        to="/wallet/deposit"
                        className="ng-tns-c810532393-4"
                      >
                        <span
                          className="ng-tns-c4049933992-86"
                          style={{
                            maskImage: 'url("/assets/Icon/icon-deposit.svg")',
                          }}
                        />
                        <p className="ng-tns-c810532393-4">{t("Deposit")}</p>
                      </Link>
                    </FadeInWhenVisible>
                    <li
                      data-category="withdrawal"
                      className="ng-tns-c810532393-4"
                      ot-tag="menu_Withdrawal_T"
                      style={{
                        opacity: 1,
                        transform: "translate(0px, 0px)",
                      }}
                    >
                      <Link
                        className="ng-tns-c810532393-4"
                        to="/wallet/withdraw"
                      >
                        <span
                          className="ng-tns-c810532393-4"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-withdrawal.svg",
                            )})`,
                          }}
                        />
                        <p className="ng-tns-c810532393-4">{t("Withdraw")}</p>
                      </Link>
                    </li>
                  </ul>
                )}

                <ul className="main-box ng-tns-c810532393-4">
                  {/* <li
                        className="ng-tns-c810532393-4 ng-star-inserted"
                        data-category="cricket"
                        ot-tag="menu_Exchange_F"
                        style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                      >
                        <Link className="ng-tns-c810532393-4" to="/sports">
                          <span
                            className="ng-tns-c810532393-4 ng-star-inserted"
                            style={{
                              maskImage: `url(${getImageUrl(
                                "/assets/Icon/icon-e2exchange.svg",
                              )})`,
                            }}
                          />

                          <p className="ng-tns-c810532393-4">{t("9WICKETS")}</p>
                        </Link>
                      </li> */}

                  <li
                    onClick={() => {
                      setActive("sports");
                    }}
                    className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                      active == "sports" ? "active" : ""
                    }`}
                    data-category="sport"
                    style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                  >
                    <a role="button" className="ng-tns-c810532393-4">
                      <span
                        className="ng-tns-c810532393-4 ng-star-inserted"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-sport.svg",
                          )})`,
                        }}
                      />

                      <p
                        style={{ textTransform: "uppercase" }}
                        className="ng-tns-c810532393-4 ng-star-inserted"
                      >
                        {" "}
                        {t("Sports")}
                      </p>
                    </a>
                  </li>

                  <li
                    onClick={() => {
                      setActive("casino");
                    }}
                    className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                      active == "casino" ? "active" : ""
                    }`}
                    style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                  >
                    <a role="button" className="ng-tns-c810532393-4">
                      <span
                        className="item-icon ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-casino.svg",
                          )})`,
                        }}
                      />
                      <p
                        style={{ textTransform: "uppercase" }}
                        className="ng-tns-c810532393-4"
                      >
                        {t("Casino")}
                      </p>
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      setActive("slots");
                    }}
                    className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                      active == "slots" ? "active" : ""
                    }`}
                    style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                  >
                    <a role="button" className="ng-tns-c810532393-4">
                      <span
                        className="item-icon ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-slot.svg",
                          )})`,
                        }}
                      />
                      <p
                        style={{ textTransform: "uppercase" }}
                        className="ng-tns-c810532393-4"
                      >
                        {t("Slots")}
                      </p>
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      setActive("table");
                    }}
                    className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                      active == "table" ? "active" : ""
                    }`}
                    style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                  >
                    <a role="button" className="ng-tns-c810532393-4">
                      <span
                        className="item-icon ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-table.svg",
                          )})`,
                        }}
                      />
                      <p
                        style={{ textTransform: "upparcase" }}
                        className="ng-tns-c810532393-4"
                      >
                        {t("Table")}
                      </p>
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      setActive("crash");
                    }}
                    className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                      active == "crash" ? "active" : ""
                    }`}
                    style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                  >
                    <a role="button" className="ng-tns-c810532393-4">
                      <span
                        className="item-icon ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-crash.svg",
                          )})`,
                        }}
                      />
                      <p
                        style={{ textTransform: "upparcase" }}
                        className="ng-tns-c810532393-4"
                      >
                        {t("Crash")}
                      </p>
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      setActive("fishing");
                    }}
                    className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                      active == "fishing" ? "active" : ""
                    }`}
                    style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                  >
                    <a role="button" className="ng-tns-c810532393-4">
                      <span
                        className="item-icon ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-fish.svg",
                          )})`,
                        }}
                      />
                      <p
                        style={{ textTransform: "upparcase" }}
                        className="ng-tns-c810532393-4"
                      >
                        {t("Fishing")}
                      </p>
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      setActive("arcade");
                    }}
                    className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                      active == "arcade" ? "active" : ""
                    }`}
                    style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                  >
                    <a role="button" className="ng-tns-c810532393-4">
                      <span
                        className="item-icon ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-arcade.svg",
                          )})`,
                        }}
                      />
                      <p
                        style={{ textTransform: "upparcase" }}
                        className="ng-tns-c810532393-4"
                      >
                        {t("Arcade")}
                      </p>
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      setActive("lottery");
                    }}
                    className={`ng-tns-c810532393-4 game-nav-item ng-star-inserted ${
                      active == "lottery" ? "active" : ""
                    }`}
                    style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                  >
                    <a role="button" className="ng-tns-c810532393-4">
                      <span
                        className="item-icon ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-lottery.svg",
                          )})`,
                        }}
                      />
                      <p
                        style={{ textTransform: "upparcase" }}
                        className="ng-tns-c810532393-4"
                      >
                        {t("Lotto")}
                      </p>
                    </a>
                  </li>
                </ul>

                <ul
                  className="contact-box ng-tns-c810532393-4"
                  style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                >
                  <li data-category="promotion" className="ng-tns-c810532393-4">
                    <Link to="/promotions" className="ng-tns-c810532393-4">
                      <span
                        className="ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-promotion.svg",
                          )})`,
                        }}
                      />
                      <p
                        style={{ textTransform: "upparcase" }}
                        className="ng-tns-c810532393-4"
                      >
                        {t("PROMOITIONS")}
                      </p>
                    </Link>
                  </li>
                  <li
                    className="ng-tns-c810532393-4 email ng-star-inserted"
                    data-category="email"
                  >
                    <a
                      target="_blank"
                      className="ng-tns-c810532393-4"
                      href="mailto:inr_support@e28.com"
                    >
                      <span
                        className="ng-tns-c810532393-4 ng-star-inserted"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-email.svg",
                          )})`,
                        }}
                      />

                      <p className="ng-tns-c810532393-4">{t("Email")}</p>
                    </a>
                  </li>
                </ul>
                <ul
                  className="home-box ng-tns-c810532393-4"
                  style={{ opacity: 1, transform: "translate(0px, 0px)" }}
                >
                  <li data-category="home" className="ng-tns-c810532393-4">
                    <Link to="/" className="ng-tns-c810532393-4">
                      <span
                        className="ng-tns-c810532393-4"
                        style={{
                          maskImage: `url(${getImageUrl(
                            "/assets/Icon/icon-home.svg",
                          )})`,
                        }}
                      />
                      <p className="ng-tns-c810532393-4">{t("Home")}</p>
                    </Link>
                  </li>
                  {isEmpty(user) ? (
                    <li
                      data-category="login"
                      className="ng-tns-c810532393-4 ng-star-inserted"
                    >
                      <Link to="/login" className="ng-tns-c810532393-4">
                        <span
                          className="ng-tns-c810532393-4"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-login.svg",
                            )})`,
                          }}
                        />
                        <p className="ng-tns-c810532393-4">{t("LogIn")}</p>
                      </Link>
                    </li>
                  ) : (
                    <li
                      data-category="logout"
                      className="ng-tns-c810532393-4 ng-star-inserted"
                    >
                      <Link
                        onClick={() => setLogoutShow(true)}
                        to="/"
                        className="ng-tns-c810532393-4"
                      >
                        <span
                          className="ng-tns-c810532393-4"
                          style={{
                            maskImage: `url(${getImageUrl(
                              "/assets/Icon/icon-logout.svg",
                            )})`,
                          }}
                        />
                        <p className="ng-tns-c810532393-4">{t("LogOut")}</p>
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>{" "}
       
        <div className="menu-second ng-tns-c810532393-4">
          <ul
            className={`ng-tns-c810532393-4 ng-star-inserted ${
              active == "sports" ? "active" : ""
            }`}
            ot-tag="menu_Sport_F"
          >
            <li className="ng-tns-c810532393-4 ng-star-inserted">
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/sports-sky";
                }}
                to="/sports-sky"
                className="ng-tns-c810532393-4"
              >
                <img
                  _ngcontent-serverapp-c1589996670
                  loading="lazy"
                  className="ng-star-inserted"
                  alt="icon-9w-cricket"
                  src="/assets/Platform/icon-9w-cricket.png"
                />
                <p className="ng-tns-c810532393-4">{t("9WICKETS")}</p>
              </Link>
            </li>{" "}
            <li className="ng-tns-c810532393-4 ng-star-inserted">
              <Link
                to="/sports-velki"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/sports-velki";
                }}
                className="ng-tns-c810532393-4"
              >
                <img
                  _ngcontent-serverapp-c1589996670
                  loading="lazy"
                  className="ng-star-inserted"
                  alt="icon-9w-cricket"
                  src="/assets/Icon/velki-favicon.ico"
                />
                <p className="ng-tns-c810532393-4">{t("Velkie")}</p>
              </Link>
            </li>{" "}
            {/* <li className="ng-tns-c810532393-4 ng-star-inserted">
                  <Link to="/sports" className="ng-tns-c810532393-4">
                    <img
                      _ngcontent-serverapp-c1589996670
                      loading="lazy"
                      className="ng-star-inserted"
                      alt="icon-9w-cricket"
                      src="/assets/Platform/icon-cricket.svg"
                    />
                    <p className="ng-tns-c810532393-4">{t("Exchange")}</p>
                  </Link>
                </li> */}
          </ul>

          <ul
            className={`ng-tns-c810532393-4 ng-star-inserted ${
              active == "casino" ? "active" : ""
            }`}
          >
            {filtercasion?.map((res) => {
              return (
                <li
                  className="ng-tns-c810532393-4 ng-star-inserted"
                  gallery-image-key="PROVIDER_AWCMPT"
                >
                  <Link
                    to={`/casino?type=casino&provider=${res?.name}`}
                    className="ng-tns-c810532393-4"
                  >
                    <img
                      className="ng-tns-c810532393-4"
                      loading="lazy"
                      alt="provider-awcmpt"
                      src={res?.image}
                    />
                    <p className="ng-tns-c810532393-4">{res?.name}</p>
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul
            className={`ng-tns-c810532393-4 ng-star-inserted ${
              active == "slots" ? "active" : ""
            }`}
          >
            {filterslot?.map((res) => {
              return (
                <li
                  className="ng-tns-c810532393-4 ng-star-inserted"
                  gallery-image-key="PROVIDER_AWCMPT"
                >
                  <Link
                    to={`/casino?type=slots&provider=${res?.name}`}
                    className="ng-tns-c810532393-4"
                  >
                    <img
                      className="ng-tns-c810532393-4"
                      loading="lazy"
                      alt="provider-awcmpt"
                      src={res?.image}
                    />
                    <p className="ng-tns-c810532393-4">{res?.name}</p>
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul
            className={`ng-tns-c810532393-4 ng-star-inserted ${
              active == "table" ? "active" : ""
            }`}
          >
            {filtertable?.map((res) => {
              return (
                <li
                  className="ng-tns-c810532393-4 ng-star-inserted"
                  gallery-image-key="PROVIDER_AWCMPT"
                >
                  <Link
                    to={`/casino?type=table&provider=${res?.name}`}
                    className="ng-tns-c810532393-4"
                  >
                    <img
                      className="ng-tns-c810532393-4"
                      loading="lazy"
                      alt="provider-awcmpt"
                      src={res?.image}
                    />
                    <p className="ng-tns-c810532393-4">{res?.name}</p>
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul
            className={`ng-tns-c810532393-4 ng-star-inserted ${
              active == "crash" ? "active" : ""
            }`}
          >
            {filtercrash?.map((res) => {
              return (
                <li
                  className="ng-tns-c810532393-4 ng-star-inserted"
                  gallery-image-key="PROVIDER_AWCMPT"
                >
                  <Link
                    to={`/casino?type=crash&provider=${res?.name}`}
                    className="ng-tns-c810532393-4"
                  >
                    <img
                      className="ng-tns-c810532393-4"
                      loading="lazy"
                      alt="provider-awcmpt"
                      src={res?.image}
                    />
                    <p className="ng-tns-c810532393-4">{res?.name}</p>
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul
            className={`ng-tns-c810532393-4 ng-star-inserted ${
              active == "fishing" ? "active" : ""
            }`}
          >
            {filterfishing?.map((res) => {
              return (
                <li
                  className="ng-tns-c810532393-4 ng-star-inserted"
                  gallery-image-key="PROVIDER_AWCMPT"
                >
                  <Link
                    to={`/casino?type=fishing&provider=${res?.name}`}
                    className="ng-tns-c810532393-4"
                  >
                    <img
                      className="ng-tns-c810532393-4"
                      loading="lazy"
                      alt="provider-awcmpt"
                      src={res?.image}
                    />
                    <p className="ng-tns-c810532393-4">{res?.name}</p>
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul
            className={`ng-tns-c810532393-4 ng-star-inserted ${
              active == "arcade" ? "active" : ""
            }`}
          >
            {filterarcade?.map((res) => {
              return (
                <li
                  className="ng-tns-c810532393-4 ng-star-inserted"
                  gallery-image-key="PROVIDER_AWCMPT"
                >
                  <Link
                    to={`/casino?type=arcade&provider=${res?.name}`}
                    className="ng-tns-c810532393-4"
                  >
                    <img
                      className="ng-tns-c810532393-4"
                      loading="lazy"
                      alt="provider-awcmpt"
                      src={res?.image}
                    />
                    <p className="ng-tns-c810532393-4">{res?.name}</p>
                  </Link>
                </li>
              );
            })}
          </ul>
          <ul
            className={`ng-tns-c810532393-4 ng-star-inserted ${
              active == "lottery" ? "active" : ""
            }`}
          >
            {filterlotto?.map((res) => {
              return (
                <li
                  className="ng-tns-c810532393-4 ng-star-inserted"
                  gallery-image-key="PROVIDER_AWCMPT"
                >
                  <Link
                    to={`/casino?type=lottery&provider=${res?.name}`}
                    className="ng-tns-c810532393-4"
                  >
                    <img
                      className="ng-tns-c810532393-4"
                      loading="lazy"
                      alt="provider-awcmpt"
                      src={res?.image}
                    />
                    <p className="ng-tns-c810532393-4">{res?.name}</p>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>{" "}
      </div>
      <div
        className="menu-mask ng-tns-c810532393-4 ng-trigger ng-trigger-popBgTriggerAni ng-star-inserted"
        style={{
          display: sidebarModal ? "block" : "none",
          opacity: sidebarModal ? 1 : 0,
        }}
      />
    </>
  );
};

export default Menu;
